import React from "react";
import {
  AnimalShelterIcon,
  ComunityKitchenIcon,
  FlCampIcon,
} from "../../../../../Components/IconComponents";
import "./FacilityRegistered.css";

const facilities = [
  {
    key: "Community Kitchen",
    label: "Community Kitchen",
    Icon: ComunityKitchenIcon,
    gradient: "linear-gradient(135deg, #0b2d4d 0%, #1a4a73 100%)",
    accent: "#59b3ff",
  },
  {
    key: "Flood Relief Camp",
    label: "Flood Relief Camp",
    Icon: FlCampIcon,
    gradient: "linear-gradient(135deg, #1a4a73 0%, #2d6da3 100%)",
    accent: "#93cfff",
  },
  {
    key: "Animal Shelter",
    label: "Animal Shelter",
    Icon: AnimalShelterIcon,
    gradient: "linear-gradient(135deg, #2d6da3 0%, #59b3ff 100%)",
    accent: "#cce7ff",
  },
];

export default function FacilityRegistered({ dataval }) {
  const total = facilities.reduce((s, f) => s + (dataval?.[f.key] || 0), 0);

  return (
    <div className="card" style={{ width: "100%", height: "95%" }}>
      <div className="card-body fr-body">
        <div className="card-title" style={{ color: "#0b2d4d" }}>
          <span className="card-title-icon">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="white">
              <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
            </svg>
          </span>
          Facility Registered
        </div>

        {/* Total pill */}
        <div className="fr-total-pill">
          <span className="fr-total-num">{total}</span>
          <span className="fr-total-lbl">Total Facilities</span>
        </div>

        {/* Facility rows */}
        <div className="fr-list">
          {facilities.map(({ key, label, Icon, gradient, accent }) => {
            const count = dataval?.[key] || 0;
            const pct   = total > 0 ? Math.round((count / total) * 100) : 0;
            return (
              <div key={key} className="fr-row">
                {/* Icon badge */}
                <div className="fr-icon-badge" style={{ background: gradient }}>
                  <Icon width="1.2rem" height="1.2rem" />
                </div>

                {/* Label + bar */}
                <div className="fr-info">
                  <div className="fr-label-row">
                    <span className="fr-label" title={label}>{label}</span>
                    <span className="fr-count">{count}</span>
                  </div>
                  <div className="fr-bar-track">
                    <div
                      className="fr-bar-fill"
                      style={{
                        width: `${pct}%`,
                        background: gradient,
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}